import React, { memo, useRef } from 'react';
import { HardDrive, Upload } from 'lucide-react';

const UploadOptions = ({ onConnectDrive, onManualUpload, showDriveOption = false }) => {
    const fileInputRef = useRef(null);

    const handleManualClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
                marginTop: "24px"
            }}
        >
            {/* Google Drive option - hidden for now, enable with showDriveOption={true} */}
            {showDriveOption && (
                <>
                    <button
                        onClick={onConnectDrive}
                        style={{
                            width: "100%",
                            maxWidth: "320px",
                            background: "#16a34a",
                            color: "white",
                            border: "none",
                            borderRadius: "12px",
                            padding: "14px",
                            fontWeight: 700,
                            fontSize: "15px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            boxShadow: "0 4px 12px rgba(22, 163, 74, 0.3)",
                            transition: "transform 0.2s"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                    >
                        <HardDrive size={20} /> Connect & Share via Drive
                    </button>

                    <div style={{ display: "flex", alignItems: "center", gap: "12px", width: "100%", maxWidth: "320px" }}>
                        <div style={{ flex: 1, height: "1px", background: "rgba(148, 163, 184, 0.3)" }}></div>
                        <span style={{ fontSize: "12px", color: "#94a3b8", fontWeight: 600 }}>OR</span>
                        <div style={{ flex: 1, height: "1px", background: "rgba(148, 163, 184, 0.3)" }}></div>
                    </div>
                </>
            )}

            <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={onManualUpload}
                style={{ display: "none" }}
            />

            <button
                onClick={handleManualClick}
                style={{
                    width: "100%",
                    maxWidth: "320px",
                    background: showDriveOption ? "rgba(59, 130, 246, 0.1)" : "#16a34a",
                    color: showDriveOption ? "#93c5fd" : "white",
                    border: showDriveOption ? "1px solid rgba(59, 130, 246, 0.3)" : "none",
                    borderRadius: "12px",
                    padding: "14px",
                    fontWeight: 700,
                    fontSize: "15px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    boxShadow: showDriveOption ? "none" : "0 4px 12px rgba(22, 163, 74, 0.3)",
                    transition: "all 0.2s"
                }}
                onMouseEnter={(e) => {
                    if (showDriveOption) {
                        e.currentTarget.style.background = "rgba(59, 130, 246, 0.15)";
                        e.currentTarget.style.color = "#fff";
                    } else {
                        e.currentTarget.style.transform = "translateY(-2px)";
                    }
                }}
                onMouseLeave={(e) => {
                    if (showDriveOption) {
                        e.currentTarget.style.background = "rgba(59, 130, 246, 0.1)";
                        e.currentTarget.style.color = "#93c5fd";
                    } else {
                        e.currentTarget.style.transform = "translateY(0)";
                    }
                }}
            >
                <Upload size={20} /> Upload Files
            </button>
        </div>
    );
};

export default memo(UploadOptions);
